import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sendEvent } from 'utils/Event';
import { toast } from 'react-toastify';
import { getExploitationInformations } from 'services/API/Exploitation';
import DataGridCulture from '../Cooperative/DataGridCulture';
import useToggleSwitch from 'utils/hooks/useToggleSwitch';
import { getCoProductsPerCooperative } from 'services/API/Cooperative';
import { useTranslation } from 'react-i18next';

function CulturesDataGridExploitation({
  exploitation,
  setExploitation,
  structureId,
  user,
  nitrogenCover,
  setNitrogenCover,
  nitrogenSupplyByCoverOrganic,
  setNitrogenSupplyByCoverOrganic,
  biomassSupplyByCover,
  setBiomassSupplyByCover,
  cultures,
}) {
  const { t } = useTranslation();
  const [exploit, setExploit] = useState(exploitation);

  const [coProductsList, setCoProductsList] = useState(null);
  const [economicAttribute, setEconomicAttribute] = useState(exploit?.economicAttributeCollection);
  const exploitId = exploit?.id ?? +localStorage.getItem('exploitation');

  const { isOrganic } = useToggleSwitch(
    'exploitations',
    'cultures',
    () => {},
    exploitId,
    null,
    null,
  );

  const navigate = useNavigate();

  useEffect(() => {
    loadData();

    return () => {
      sendEvent('cancelHttpRequest');
    };
  }, []);

  const loadData = () => {
    if (localStorage.getItem('exploitation')) {
      setExploitation(isOrganic, exploitId, false, false, null)
        .then(
          (resp) => (
            setExploit(resp.data.data),
            setEconomicAttribute(resp.data.data?.economicAttributeCollection),
            setNitrogenCover({ nitrogenSupplyByCover: resp.data.data?.nitrogenSupplyByCover }),
            setNitrogenSupplyByCoverOrganic({
              nitrogenSupplyByCoverOrganic: resp.data.data?.nitrogenSupplyByCoverOrganic,
            }),
            setBiomassSupplyByCover({ biomassSupplyByCover: resp.data.data?.biomassSupplyByCover })
          ),
        )
        .catch((err) => toast.error(err.data));
      getCoProducts();
    } else {
      toast.info(t('message.selectExploitation'));
      navigate('/exploitation');
    }
  };

  const getCoProducts = async () => {
    const cooperativeId = Number(localStorage.getItem('cooperative'));
    try {
      const result = await getCoProductsPerCooperative(cooperativeId);
      const { data } = result.data;
      setCoProductsList([{ id: null, displayName: t('common.none') }].concat(data));
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message);
    }
  };

  const getOffCropSettings = async () => {
    try {
      const result = await getExploitationInformations(exploitId);
      const data = result.data;
      setEconomicAttribute(data.data?.economicAttributeCollection);
    } catch (error) {
      toast.error(error.data);
    }
  };

  return (
    <DataGridCulture
      columnsDefinition={cultures.metadata}
      from={'fromExploitation'}
      cultures={cultures?.data}
      refreshData={setExploitation}
      exploitation={exploit}
      structureId={structureId}
      coProductsList={coProductsList}
      setCoProductsList={setCoProductsList}
      economicAttribute={economicAttribute}
      getOffCropSettings={getOffCropSettings}
      nitrogenCover={nitrogenCover}
      nitrogenSupplyByCoverOrganic={nitrogenSupplyByCoverOrganic}
      biomassSupplyByCover={biomassSupplyByCover}
      user={user}
    />
  );
}

export default CulturesDataGridExploitation;
